import { Button, Checkbox, Flex, Box, Icon, Td, Text } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { CircleFlag } from 'react-circle-flags'
import { ArrowUpRightIcon } from '../../../assets/icons'
import { Column, RowData } from './MasterTable'

interface TableCellProps {
  column: Column
  value: any
  row: RowData
  onDelete?: (row: RowData) => void
  onEdit?: (row: RowData) => void
  onCopyLink?: (row: RowData) => void
  onOpenNewTab?: (row: RowData) => void
  onSearch?: (row: RowData) => void
  onDownload?: (row: RowData) => void
  isSelected: boolean
  onSelectRow: (id: number | string, isChecked: boolean) => void
  tableType: 'people' | 'teams' | 'jobs' | 'skills' | 'aboutorg' | 'documents' | 'content' | 'paths' | 'assets' | 'evaluations' | 'past-requests' | 'leave-requests' | 'leave-balances' | 'attendance' | 'public-holidays'
  isHovered: boolean
  onRowClick?: (row: RowData) => void
}

const TableCell: React.FC<TableCellProps> = ({
  column,
  value,
  row,
  onOpenNewTab,
  isSelected,
  onSelectRow,
  tableType,
  isHovered,
  onRowClick,
}) => {
  const { t } = useTranslation()
  const emptyLabel = t('common.labels.na')

  const handleOpenNewTab = () => {
    if (onOpenNewTab) {
      onOpenNewTab(row)
    }
  }

  const handleRowClick = () => {
    if (onRowClick) {
      onRowClick(row)
    }
  }

  if (column.Cell) {
    return (
      <Td
        onClick={handleRowClick}
        maxW={column.width ?? '240px'}
        overflow="hidden"
        py="10px"
      >
      <Flex minW={0}>
        <Box
          maxW="100%"
        >
        <column.Cell row={row} />
      </Box>
      </Flex>
    </Td>
    )
  }

  switch (column.type) {
    case 'string':
      return (
        <Td
          onClick={handleRowClick}
          maxW={column.width ?? '240px'}
          overflow="hidden"
          py="10px"
        >
          <Text
            textStyle="l-xs"
            isTruncated
            title={value ?? emptyLabel}
          >
            {value ?? emptyLabel}
          </Text>
        </Td>
      )

    case 'actions':
      return (
        <Td textAlign="center" py="10px">
          {onOpenNewTab && (
            <Button
              variant={'actions'}
              onClick={(e) => {
                e.stopPropagation()
                handleOpenNewTab()
              }}
              visibility={isHovered ? 'visible' : 'hidden'}
              textStyle="l-xs"
            >
              Open in new tab
              <Icon width="12px" height="12px" fill="none" color="solid.500">
                <ArrowUpRightIcon />
              </Icon>
            </Button>
          )}
        </Td>
      )

    case 'select':
      return (
        <Td width="1%" onClick={(e) => e.stopPropagation()} py="10px">
          <Checkbox
            isChecked={isSelected}
            onChange={(e) => onSelectRow(row.id, e.target.checked)}
          />
        </Td>
      )

    case 'custom':
      return (
        <Td onClick={handleRowClick} py="10px">
          <Flex alignItems="center">
            <CircleFlag countryCode={row.countryCode} style={{ width: '24px', height: '24px', marginRight: '8px' }} />
            <Text textStyle="l-xs">{value}</Text>
          </Flex>
        </Td>
      )

    default:
      return <Td onClick={handleRowClick} py="10px" />
  }
}

export default TableCell
